export enum GradeSize {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
}
